// Written by desktop/scripts/stamp-version.js. Do not edit by hand.
export const VERSION = "0.9.249";
export const BUILT_AT = "5 nov 16:44";
export const BUILT_AT_ISO = "2026-11-05T15:44:10.336Z";
